export default __webpack_public_path__ + "static/media/AdminManager-01.4a27e1cb.png";